<template>
  <div id="contratos-user-select">
    <v-autocomplete
      v-model="filter.contratos"
      item-text="numContrato"
      item-name="numContrato"
      item-value="numContrato"
      :items="contratos"
      label="Contratos"
      placeholder="Contratos"
      v-on:change="handleChange"
      :disabled="disabled"
      :return-object="true"
      :loading="loading"
      :multiple="multiple"
      :chips="multiple"
      :small-chips="multiple"
      :deletable-chips="multiple"
      :hide-selected="multiple"
      :close-on-select="!multiple"
      :hint="hint"
      persistent-hint
    >
      <div
        v-if="multiple"
        style="display: flex; padding: 0 16px; cursor: pointer"
        slot="prepend-item"
        ripple
        @click="toggle"
      >
        <div style="margin-right: 32px">
          <v-icon
            :color="
              filter.contratos && filter.contratos.length > 0
                ? 'indigo darken-4'
                : ''
            "
            >{{ icon }}</v-icon
          >
        </div>
        <div>Todos</div>
      </div>
      <v-divider v-if="multiple" slot="prepend-item" class="mt-2" />

      <template v-slot:selection="{ item, index }">
        <v-card
          v-if="index < maxDisplay"
          class="ma-1 pa-2"
          flat
          style="min-width: 180px"
        >
          <v-card-subtitle class="pa-1 pb-0">
            <div class="font-weight-bold text-body-2 primary--text">
              {{ item.numContrato }}
            </div>
            <div class="text-caption grey--text mt-1 d-flex align-center">
              <div class="d-flex align-center">
                <v-icon small class="mr-1">mdi-account</v-icon>
                {{
                  item.usuario && item.usuario.nome
                    ? item.usuario.nome.length > 20
                      ? item.usuario.nome.substring(0, 20) + "..."
                      : item.usuario.nome
                    : "Usuário não informado"
                }}
              </div>
              <div
                v-if="item.qtdEntregasPrevistas"
                class="d-flex align-center ml-3"
              >
                <v-icon small class="mr-1">mdi-package-variant</v-icon>
                {{ item.qtdEntregasPrevistas }} entregas
              </div>
            </div>
          </v-card-subtitle>
        </v-card>
        <span
          v-if="index === maxDisplay"
          class="grey--text text-caption ma-2 mb-3"
        >
          (+{{ filter.contratos.length - maxDisplay }} contratos)
        </span>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.numContrato }}</v-list-item-title>
          <v-list-item-subtitle
            class="text-caption grey--text d-flex align-center"
          >
            <v-icon small class="mr-1">mdi-account</v-icon>
            {{ item.usuario.nome }}
            <span
              v-if="item.qtdEntregasPrevistas"
              class="ml-2 d-flex align-center"
            >
              <v-icon small class="mr-1 ml-1">mdi-package-variant</v-icon>
              Entregas Previstas: {{ item.qtdEntregasPrevistas }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>

      <template slot="no-data"> Nenhum Contrato </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { contratosAPI } from "@/apis";
import { mapActions } from "vuex";

export default {
  name: "ContratosPorUsuarioCombobox",
  props: {
    filter: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    user: { type: Number | Array },
    multiple: { type: Boolean, default: false },
    hint: { type: String, default: null },
  },
  mounted() {
    this.load();
  },
  watch: {
    "filter.contratoId": {
      handler(newVal) {
        this.selectedContrato = this.contratos.find(
          (item) => item.contratoId == newVal
        );
      },
      deep: true,
    },
    user: {
      handler(e) {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    likesAll() {
      return (
        this.filter.contratos &&
        this.filter.contratos.length === this.contratos.length
      );
    },
    likesSome() {
      return (
        this.filter.contratos &&
        this.filter.contratos.length > 0 &&
        !this.likesAll
      );
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.contratos = [];
        } else {
          this.filter.contratos = this.contratos.slice();
        }
        this.$emit("onChange", this.filter.contratos);
      });
    },

    handleChange(value) {
      if (!this.multiple) {
        this.$emit("onChange", value);
        return;
      }

      this.filter.contratos = value || [];
      this.$emit("onChange", this.filter.contratos);
    },

    load() {
      this.contratos = [];
      this.loading = true;
      contratosAPI[this.multiple ? "listByUsers" : "listByUser"](
        Array.isArray(this.user) ? this.user : [this.user]
      )
        .then((resp) => {
          this.loading = false;
          this.contratos = resp.data;

          if (!this.multiple && this.filter.contratoId) {
            this.filter.contratos = this.contratos.find(
              (item) => item.contratoId == this.filter.contratoId
            );
          }
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Contratos");
        });
    },
  },
  data() {
    return {
      maxDisplay: 1,
      contratos: [],
      loading: false,
      selectedContrato: null,
    };
  },
};
</script>

<style lang="scss">
#contratos-user-select {
  /* Garante que os cards não quebrem o layout */
  .v-select__selections {
    flex-wrap: wrap !important;
    align-items: end !important;
  }

  /* Melhora o espaçamento dos cards */
  .v-card {
    margin: 2px;
  }
}
</style>
